import React from 'react';
import Button3D from '../ui/Button3D';
import { AI_STATUS_OPTIONS } from '../../lib/businessSchedule';

// BL-177 Step 2m: the four status buttons every AI feature starts with: Off / On / Pause / Test.
// The current one is shown pressed (teal and sunk). Only the buttons show until one is chosen.
export default function AiStatusButtons({ value, onChoose, disabled = false, label = 'AI status' }) {
    return (
        <div role="group" aria-label={label} className="flex flex-wrap gap-3" data-testid="ai-status-buttons">
            {AI_STATUS_OPTIONS.map((option) => {
                const current = option.value === value;
                return (
                    <Button3D
                        key={option.value}
                        variant={current ? 'go' : 'light'}
                        aria-pressed={current}
                        disabled={disabled}
                        title={option.hint}
                        className="min-w-[5.5rem]"
                        data-status={option.value}
                        onClick={() => onChoose(option.value)}
                    >
                        {option.label}
                    </Button3D>
                );
            })}
        </div>
    );
}
